module.exports = __webpack_public_path__ + "static/adicaoPonto-fc0316ea6e4cf793168ce312f78e1612.gif";